import angular from 'angular';
import 'ui-select';
import 'angular-bootstrap';
import './userMessagesServices';

const userMessagesControllers = angular.module('applicationModule.userMessagesControllers', [
    'applicationModule.userMessagesServices',
    'ui.bootstrap',
    'ui.select'
]);


userMessagesControllers.controller('UserMessagesController', ['$scope', '$rootScope', '$stateParams', '$state', 'NgTableParams', 'Messages', 'AppsoupAPI', 'Permissions', 'growl', function ($scope, $rootScope, $stateParams, $state, NgTableParams, Messages, AppsoupAPI, Permissions, growl) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('messages');

    $scope.application_id = $stateParams.application_id;
    $scope.tableParamsQueue = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoadingQueue = true;
            return Messages.getListQueue($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);
                    var json;
                    for (var i = 0, len = response.data.length; i < len; i++) {
                        json = angular.fromJson(response.data[i].message);
                        response.data[i].message = json.message;
                        json = angular.fromJson(response.data[i].user_filter);
                        response.data[i].phone_system = json.phone_system;
                    }
                    return response.data;
                })
                .finally(function () {
                    $scope.isLoadingQueue = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });
    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Messages.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);
                    for (var i = 0, len = response.data.length; i < len; i++) {
                        var json = angular.fromJson(response.data[i].message);
                        response.data[i].message = json.message;
                    }
                    return response.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.createMessage = function () {
        $state.go('appsoup.application.newMessage');
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removePush = function (id, index) {
        Messages.remove(id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.MESSAGES.SUCCESS.DELETE');
                    $scope.tableParamsQueue.data.splice(index, 1);
                } else {
                    growl.error('MODULES.MESSAGES.ERROR.DELETE');
                }
            });
    };

}]);

userMessagesControllers.controller('UserMessagesSendController', ['$scope', '$rootScope', '$stateParams', '$state', '$anchorScroll', 'MessagesAPI', 'growl', '$filter', 'App', function ($scope, $rootScope, $stateParams, $state, $anchorScroll, MessagesAPI, growl, $filter, App) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.date = new Date();
    $scope.input = {};
    $scope.options = {};
    $scope.input.message = '';
    $scope.errorMessage = false;
    $scope.input.application_id = $stateParams.application_id;
    $scope.ios = true;
    $scope.options.start_date = $filter('date')($scope.date.getTime(), 'yyyy-MM-dd');
    $scope.options.end_date = $filter('date')($scope.date.getTime(), 'yyyy-MM-dd');
    $scope.options.day_interval = 1;
    $scope.appName = undefined;
    $scope.app_type_notification = true;
    $scope.input.applicationRecipients = false;

    App.getMenu().then(function (response) {
        if (angular.isDefined(response)) {
            if (response.applications.total === 1) {
                $scope.appName = response.applications.data[0].name;
            } else {
                angular.forEach(response.application, function (v) {
                    if (v.id == $stateParams.application_id) {
                        $scope.appName = v.name;
                    }
                });
            }
        }
        if (angular.isUndefined($scope.appName)) {
            $scope.appName = 'app name';
        }
    });

    App.get($stateParams.application_id).then(function (response) {
        $scope.app_type_notification = response.data.application.type_notification;
        if ($scope.app_type_notification === false) {
            $scope.input.applicationRecipients = true;
            $scope.input.ios = true;
            $scope.input.android = true;
        } else {
            $scope.input.applicationRecipients = false;
            $scope.input.ios = false;
            $scope.input.android = false;
        }
    });

    $scope.changeMessage = function () {
        if ($scope.input.message.trim().length === 0) {
            $scope.errorMessage = true;
        } else {
            $scope.errorMessage = false;
        }
    };
    $scope.changeRecipients = function () {
        if (!$scope.app_type_notification) {
            if ($scope.input.applicationRecipients !== true) {
                $scope.errorChoose = true;
                $scope.input.ios = false;
                $scope.input.android = false;
            } else {
                $scope.errorChoose = false;
                $scope.input.ios = true;
                $scope.input.android = true;
            }
        } else {
            if ($scope.input.ios !== true && $scope.input.android !== true) {
                $scope.errorChoose = true;
            } else {
                $scope.errorChoose = false;
            }
        }
    };
    $scope.changeBackground = function (phone) {
        if (phone === 'ios') {
            $scope.ios = true;
            $scope.android = false;
        }
        if (phone === 'android') {
            $scope.android = true;
            $scope.ios = false;
        }
    };
    $scope.changeInterval = function () {
        // var patt = /^\d+$/;
        var patt = /^[1-9][0-9]{0,7}$/;
        if (patt.test(($scope.options.day_interval).toString())) {
            $scope.errorInterval = false;
        } else {
            $scope.errorInterval = true;
        }
    };
    $scope.sendMessage = function () {
        if ($scope.input.ios !== true && $scope.input.android !== true) {
            $scope.errorChoose = true;
            $anchorScroll(['recipents_anchor']);
        }
        if ($scope.input.message.trim().length === 0) {
            $scope.errorMessage = true;
        } else {
            $scope.phone = [];
            if ($scope.input.ios === true) {
                $scope.phone.push(1);
            }
            if ($scope.input.android === true) {
                $scope.phone.push(2);
            }
            delete $scope.input.ios;
            delete $scope.input.android;
            delete $scope.input.applicationRecipients;
            $scope.input.application_id = $stateParams.application_id;
            MessagesAPI.sendMessage($scope.input, $scope.phone, $scope.options)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.MESSAGES.RECIPIENT.SUCCESS');
                        $state.go('appsoup.application.messages');
                    }
                    if (data.recipients === false) {
                        growl.error('MODULES.MESSAGES.RECIPIENT.MISSING');
                    }
                    if (data.error) {
                        angular.forEach(data.error, function (val, key) {
                            if (key === 'message.application_id') {
                                growl.error('MODULES.MESSAGES.RECIPIENT.CHOOSEAPP');
                            }
                            if (key === 'message.message') {
                                $scope.errorMessage = true;
                            }
                        });
                    }
                });
        }
    };
}]);

export default userMessagesControllers;
